<template>
  <div class="simple-notes-page">
    <PageHeader
      :title="title"
      :subtitle="subtitle"
      :actions="actions"
      @action="emitAction"
    >
      <template v-if="$slots.left" #left>
        <slot name="left" />
      </template>

      <template v-if="$slots.actions" #actions="slotProps">
        <slot name="actions" v-bind="slotProps" />
      </template>
    </PageHeader>

    <div class="simple-notes-content">
      <slot name="metrics"></slot>
      <slot name="toolbar"></slot>
      <slot name="tabs"></slot>
      <slot name="table"></slot>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue';

export default {
  name: 'SimpleNotesPageShell',
  components: {
    PageHeader,
  },
  props: {
    title: {
      type: String,
      default: 'Nota simple',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['action'],
  methods: {
    emitAction(action) {
      this.$emit('action', action);
    },
  },
};
</script>

<style scoped>
.simple-notes-page {
  display: flex;
  flex-direction: column;
}

.simple-notes-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

@media (max-width: 767px) {
  .simple-notes-content {
    padding: 12px;
  }
}
</style>
